export default "__VITE_ASSET__Bm2D0x0B__"